export default {
    en: {
        PAGE_SKIP_TO_MAIN_CONTENT: 'Skip to main content',
        PAGE_TITLE_LEVEL_SELECT: 'Mission Select',
        PAGE_TITLE_REPORT_CARD: 'Mission Log',
        BRAND : {
            VACR: "Virginia Cyber Range",
            USCR: "US Cyber Range"
        }
    }
};
